import { uploadFile } from 'api';

/**
 * @function addFileId
 * @async
 * @param { object } user
 * @returns { Promise<object> } user
 */
async function addFileId(user) {
	if (user.Image.file !== '') {
		const data = await uploadFile(user.Image.file);
		user.VFileId = data.Payload.Id;
	}
	return user;
}

export default addFileId;
